import axios, { AxiosResponse } from "axios";
import React, { FC, useContext, useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { Dimmer, Input, Loader, Segment } from "semantic-ui-react";
import { config } from "../../contexts/UrlContext";
import { IGrid, IGridField } from "../Interfaces/TableInterface";
import { FieldContext } from "../../contexts/FieldsContext";
import MetaListItem from "./MetaListItem";

import AuthContext from "../../contexts/AuthContext";
import { getRequest } from "../../services/axiosService";

interface IProps {
    title: string,
    subtitle: string,
    id: string
}

const MetaListBox: FC<IProps> = ({ title, subtitle, id }) => {

    const { auth } = useContext(AuthContext);

    
    const [search, setSearch] = useState<string>("");
    const [metaFields, setMetaFields] = useState<IGridField[]>([]);
    const [selectedFields, setSelectedFields] = useState<IGridField[]>([]);
    const [loading, setLoading] = useState(true);

    const { fields, setFields } = useContext(FieldContext);

    useEffect(() => {
        getMetaDataFields();
        setSelectedFields(fields);
    }, [fields]);

    const getMetaDataFields = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/Search/GetAllFields`);

            let data = response.data.map((x: IGridField) => {
            let obj = fields.filter((y: IGridField) => y.propertyId === x.propertyId);

            if (obj && obj.length === 1) {
                x = obj[0];
            }

            return x;
            });
            setMetaFields(data);
            setLoading(false);
        } catch (error) {
            console.log(error);
            toast.error(`Unable to retrieve fields`);
            setLoading(false);  
        }
    }

    const onSelected = (field: IGridField, selected: boolean) => {

        let updatedList = fields;

        //preset the column width for changing later
        field.colWidth = 1;

        if (selected) {
            updatedList = [...fields, field]
        } else {
            updatedList = fields.filter((x: IGridField) => x.propertyId !== field.propertyId);
        }
        setSelectedFields(updatedList);
        setFields(updatedList);
    }

    return (
        <div id={id}>
            <div className="header gray headerStyleGray" style={{ marginLeft: 0 }}>{title}</div>
            <div className="meta" style={{ marginBottom: 5 }}>{subtitle}</div>

            <Input id="field-search" className="bgGrey" fluid icon='search' placeholder='Search fields...'
                onChange={(e) => { setSearch(e.target.value) }} />
            <Segment style={{ overflowY: "auto", height: "300px" }} id={`${id}-fields`}>
                {loading &&
                    <Dimmer inverted active={true}>
                        <Loader inverted>Loading Fields...</Loader>
                    </Dimmer>
                }
                {metaFields && metaFields.length > 0 &&
                    metaFields.filter((item: IGridField) => {
                        return item.name.toLowerCase().includes(search.toLowerCase())
                    })
                    .map((item: IGridField) => {
                            return <MetaListItem key={item.propertyId} item={item} onSelectedCallback={onSelected} />
                        })
                }
            </Segment>
        </div>
    );
}

export default MetaListBox;